
<template>
  <div>
    <dd-dialog-modal
        :title="title"
        :description="description"
        :visible="visible"
        @cancel="cancel"
        v-bind="$attrs"
    >
      <template v-slot:buttons>
        <dd-button :type="cancelButtonType" outline @click="cancel" data-dusk="dialog-modal-cancel-button">{{ cancelText }}</dd-button>
        <dd-button :type="okButtonType" @click="ok" data-dusk="dialog-modal-ok-button">{{ okText }}</dd-button>
      </template>
    </dd-dialog-modal>
    <div @click="activate">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import BootstrapTypes from "~/new_design_components/enums/BootstrapTypes";

export default {
  name: "ConfirmModal.vue",
  emits: ['confirm'],
  props: {
    title: {
      type: String,
      required: false
    },
    description: {
      type: String,
      required: false
    },
    cancelText: {
      type: String,
      required: false,
      default: 'Nee'
    },
    cancelButtonType: {
      type: {
        validator(value) {
          return Object.values(BootstrapTypes).includes(value);
        },
        default() {
          return BootstrapTypes.primary
        }
      }
    },
    okText: {
      type: String,
      required: false,
      default: 'Ja'
    },
    okButtonType: {
      type: {
        validator(value) {
          return Object.values(BootstrapTypes).includes(value);
        },
        default() {
          return BootstrapTypes.primary
        }
      }
    },
  },
  data() {
    return {
      visible: false
    };
  },
  methods: {
    activate(){
      this.visible = true;
    },
    cancel() {
      this.visible = false;
    },
    ok(){
      this.visible = false;
      this.$emit('confirm');
    }
  },
  computed:{
    isVisible(){
      return this.visible;
    }
  },
  beforeDestroy() {
    const html = document.getElementsByTagName('html')[0];
    html.style.overflowY = 'scroll';
  },
  watch:{
      visible(newV){
          const html = document.getElementsByTagName('html')[0];
          newV ? html.style.overflowY = 'hidden' : html.style.overflowY = 'scroll';
      },
      value(newV){
          const html = document.getElementsByTagName('html')[0];
          newV ? html.style.overflowY = 'hidden' : html.style.overflowY = 'scroll';
      },
  }
};
</script>
<style lang="scss" scoped>
@import "~@/_default.scss";
.transparent {
  background-color: transparent;
}
</style>
<style lang="scss">
@import "~@/_default.scss";
.custom-modal {
  overflow-y: scroll;
  .ant-modal-content {
    background-color: transparent;
    border-radius: 0;
  }
}
</style>
